
import { useFacetsStore, usePinia, useSearchStore } from '#imports'
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { Facet } from '~/apps/facets/domain/facetGroups'
import { SearchFilters } from '~/apps/search/schemas'

@Component<SearchSummaryBarDetailsFacets>({
  setup() {
    const searchStore = useSearchStore(usePinia())
    const facetsStore = useFacetsStore()
    return { searchStore, facetsStore }
  },
})
export default class SearchSummaryBarDetailsFacets extends Vue {
  searchStore: ReturnType<typeof useSearchStore>
  facetsStore: ReturnType<typeof useFacetsStore>

  @Prop()
    searchFilters: SearchFilters

  @Prop({ default: true })
    useLink: boolean

  get facilities(): string[] {
    return this.searchFilters.facets || []
  }

  get facets() {
    return this.facilities
      .map((slug) => this.facetsStore.facetsBySlug(slug))
      .filter((facet) => facet)
      .map((facet) => ({
        ...facet,
        name:
          (this.searchStore?.context?.results?.facetModels &&
            this.searchStore?.context?.results?.facetModels[facet.slug]
              ?.name) ||
          facet.name,
      }))
      .sort((a, b) => a.name.localeCompare(b.name))
      .reduce((acc, facet) => {
        acc[facet.slug] = facet
        return acc
      }, {} as Record<string, Facet>)
  }

  searchFiltersWithoutFacet(slug: string) {
    const facets = this.facilities.filter((f) => f !== slug)
    return {
      ...this.searchFilters,
      facets,
    }
  }
}
